import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ClientTypeEnum } from "@models/core/client-type";
import { IMenuItemModel } from "@models/core/menu";
import {
  IApiResponse,
  IApiResponsePagination,
} from "@models/http/http-options";
import { DictionaryService } from "@dmms/core/http";
import { AdministrationEndpoints } from "@app/shared/data-access/src/lib/administration/types/administration-endpoints";

@Injectable({
  providedIn: "root",
})
export class MenuService extends DictionaryService {
  getMenuBySlug(
    slug: string,
    clientType: ClientTypeEnum = ClientTypeEnum.WebClient,
    searchTerm = "",
    version = 1,
  ): Observable<IApiResponsePagination<IMenuItemModel[]>> {
    return this.get(
      `v${version}/${AdministrationEndpoints.MenuItem.replace("{slug}", slug)}`,
      { clientType, sorts: "weight", searchTerm },
    );
  }

  createMenuItems(
    menuId: string,
    data: Partial<IMenuItemModel>,
    version = 1,
  ): Observable<IApiResponse<any>> {
    return this.post(
      `v${version}/menu/${menuId}/menu-item`,
      data,
    );
  }

  getMenuItem(
    menuId: string,
    itemId: string,
    version = 1,
  ): Observable<IApiResponse<IMenuItemModel>> {
    return this.get(
      `v${version}/menu/${menuId}/menu-item/${itemId}`,
    );
  }

  updateMenuItem(data: Partial<IMenuItemModel>, version = 1): Observable<any> {
    return this.put(
      `v${version}/menu/${data.menuId}/menu-item/${data.id}`,
      data,
    );
  }

  deleteMenuItem(menuId: string, itemId: string, version = 1): Observable<any> {
    return this.remove(
      `v${version}/menu/${menuId}/menu-item/${itemId}`,
    );
  }

  getHelpDeskLink(version = 1): Observable<IApiResponse<string>> {
    return this.get(`v${version}/helpdesk/auth-link`);
  }
}
